import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
//plugins
import NowUIKit from "./plugins/now-ui-kit";

import ApolloClient from "apollo-boost";
import VueApollo from "vue-apollo";

Vue.config.productionTip = false;
Vue.use(NowUIKit);
Vue.use(VueApollo);

const client_admin = {
  uri: process.env.VUE_APP_graphqlServerUrl
};

const create_admin = new ApolloClient({
  ...client_admin
});

const admin_gql_api = create_admin;

const apolloProvider = new VueApollo({
  clients: {
    admin_gql_api
  },
  defaultClient: admin_gql_api
});

new Vue({
  router,
  apolloProvider,
  render: h => h(App)
}).$mount("#app");
